export default __webpack_public_path__ + "static/media/Teaching-hover.b226d55f.svg";